import { render, staticRenderFns } from "./ForestGallery.vue?vue&type=template&id=65959946&scoped=true&"
import script from "./ForestGallery.vue?vue&type=script&lang=ts&"
export * from "./ForestGallery.vue?vue&type=script&lang=ts&"
import style0 from "./ForestGallery.vue?vue&type=style&index=0&id=65959946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65959946",
  null
  
)

export default component.exports